import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Paragraph, Hero, H2 } from 'scy/text';
import { WideContainer } from 'scy/layouts';
import padding from 'scy/padding.mod.scss';
import { top_md } from 'scy/margin.mod.scss';
import { textCenter } from 'scy/utils.mod.scss';
import PartyFoulIcon from 'images/icons/party-foul.svg?react-svg';
import config from 'sharedConfig';
import classnames from 'classnames';
import queryString from 'query-string';

const emjayTeal = '#2bb0a7';
const EmjayURL = config.emjay.url;
const tracking_param =
  '&utm_source=saucey&utm_medium=ios&utm_campaign=in_app_icon';

const AccountLinked = () => {
  const [seconds, setSeconds] = useState(3);
  const location = useLocation();

  useEffect(() => {
    const search = location && location.search ? location.search : '';
    const values = queryString.parse(search);
    const token = values && values.token ? values.token : '';
    if (!token) return null;
    
    setTimeout(() => {
      if (seconds === 1) {
        window.location = EmjayURL + '/storefront?s=' + token + tracking_param;
      }
      setSeconds(seconds - 1);
    }, 1000);
  }, [seconds, location]);

  return (
    <WideContainer className={classnames(textCenter, padding.lg, top_md)}>
      <Paragraph>You will be redirected to</Paragraph>
      <H2 style={{ color: `${emjayTeal}` }}>heyemjay.com</H2>
      <br />
      <Paragraph>in</Paragraph>
      <br />
      <Hero style={{ color: `${emjayTeal}` }}>{seconds}</Hero>
    </WideContainer>
  );
};

export default AccountLinked;
